import { prequalificationForm, contentFulFields } from '../utils/constant';

const {
  existingInternetConnection,
  telusWorkplace,
  fieldCustomerSegment,
  fieldRecontractCustomer
} = contentFulFields[prequalificationForm];

export const isChannelBSEorBSW = (fields, name, no, valueSegmentSmb1To30) => {
  if (name === existingInternetConnection) {
    if (
      (fields[fieldCustomerSegment].value === valueSegmentSmb1To30 &&
        fields[fieldRecontractCustomer].value === no) || // Display 'existingInternetConnection' for 'smb1To30' segment, but hide it in renewal contracts
      (fields[fieldCustomerSegment].value !== valueSegmentSmb1To30 &&
        fields[telusWorkplace].value === no)
    )
      return true;
    return false;
  }
  return undefined;
};

export const getValueFromEligibleStep = () => undefined;
